import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_FORM_COMPLETIONS = gql`
  query fetchFormCompletions($input: FetchFormCompletionsInput!) {
    fetchFormCompletions(input: $input) {
      formCompletions {
        id
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        resolvedPdfFileName { ${TRANSLATED_STRING_FIELDS} }
        state
        signingType
        integrationFormPack {
          id
          state
        }
      }
      totalCount
    }
  }
`;
